import React from "react";
import { compose } from "recompose";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Card, ListGroup, ListGroupItem, Progress } from "reactstrap";

import { Icon } from "@ui/Icon";
import { Spinner } from "@ui/Spinner";
import { messages } from "../../messages";
import { ApiRequest } from "../../requests";
import { ApiState } from "../../models/state";
import { getRequestsInProgress } from "../../selectors";

interface RequestsInProgressStateProps {
    requests: ApiRequest[];
}

type Props = RequestsInProgressStateProps;
type State = ApiState;

const Request = ({ request }: { request: ApiRequest }) => {
    let colour: string = null;
    let icon: JSX.Element = <Spinner inline />;
    let text: JSX.Element = <FormattedMessage {...messages.fileUpload} />;
    if (request.options != null && request.options.body instanceof File) {
        text = <span>{request.options.body.name}</span>;
    }
    if (request.isFinishedFailed()) {
        colour = "danger";
        icon = <Icon name="times" />;
    }
    else if (request.isFinishedSucceeded()) {
        colour = "success";
        icon = <Icon name="check" />;
    }
    return (
        <ListGroupItem className="requests-in-progress__request" color={colour}>
            <div className="requests-in-progress__file">
                {icon}{" "}{text}
            </div>
            {colour == null &&
                <Progress
                    className="requests-in-progress__progress"
                    value={request.progress * 100}
                />
            }
        </ListGroupItem>
    );
};

const RequestsInProgress = ({ requests }: Props) => (
    <div className="requests-in-progress">
        {requests.length > 0 &&
            <Card>
                <ListGroup flush>
                    {requests.map((request, i) =>
                        <Request key={i} request={request} />,
                    )}
                </ListGroup>
            </Card>
        }
    </div>
);

const mapStateToProps = (state: State) => ({
    requests: getRequestsInProgress(state),
} as RequestsInProgressStateProps);

const ConnectedRequestsInProgress = compose<Props, {}>(
    connect(mapStateToProps, null),
)(RequestsInProgress);

export {
    RequestsInProgress as RequestsInProgressPresenter,
    ConnectedRequestsInProgress as RequestsInProgress,
};
